import { render, staticRenderFns } from "./with_ecord.vue?vue&type=template&id=1af07ce5"
import script from "./with_ecord.vue?vue&type=script&lang=js"
export * from "./with_ecord.vue?vue&type=script&lang=js"
import style0 from "./with_ecord.vue?vue&type=style&index=0&id=1af07ce5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports